import React from "react";
import Navigation from "../components/Navigation";
import EnterpriseOrganizationAssessmentCard from "../components/EnterpriseOrganizationAssessmentCard";

const EnterpriseOrganizations = () => {
  return (
    <div className="min-h-screen bg-theme-primary">
      {/* Top Navigation */}
      <Navigation />

      {/* Page Content */}
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-content-primary">
            <span className="text-blue-800">Organization Assessments</span>
          </h1>
          <p className="mt-2 text-content-secondary">Manage organization risk assessment</p>
        </div>

        {/* 🔥 Reusable Card */}
        <EnterpriseOrganizationAssessmentCard />
      </div>
    </div>
  );
};

export default EnterpriseOrganizations;
